import React from 'react';
import { CodeStyles } from './CodeStyles';
export var LineNumbers = function (_a) {
    var text = _a.text, forwardRef = _a.forwardRef;
    var lineCount = text.split('\n').length;
    var linesArray = Array.from({ length: lineCount }, function (_, i) { return i + 1; });
    return (React.createElement("div", { ref: forwardRef, style: CodeStyles.lineNumbers }, linesArray.map(function (lineNumber) { return (React.createElement("div", { key: lineNumber }, lineNumber)); })));
};
//# sourceMappingURL=LineNumbers.js.mapimport React from 'react';
import { CodeStyles } from './CodeStyles';
export var LineNumbers = function (_a) {
    var text = _a.text, forwardRef = _a.forwardRef;
    var lineCount = text.split('\n').length;
    var linesArray = Array.from({ length: lineCount }, function (_, i) { return i + 1; });
    return (React.createElement("div", { ref: forwardRef, style: CodeStyles.lineNumbers }, linesArray.map(function (lineNumber) { return (React.createElement("div", { key: lineNumber }, lineNumber)); })));
};
//# sourceMappingURL=LineNumbers.js.map